import React, { useCallback } from 'react';

const TestMenu = (props) => {

    const callCommonTest = useCallback(() => {
        props.setCommon(true);
    }, [props]);

    /*const callPincodeTest = useCallback(() => {
        props.setPincode(true);
    }, [props]);*/

    const callKeypadTest = useCallback(() => {
        props.setKeypad(true);
    }, [props]);

    const callPhotoUploadTest = useCallback(() => {
        props.setPhotoUpload(true);
    }, [props]);

    const callAddressUploadTest = useCallback(() => {
        props.setAddressUpload(true);
    }, [props]);

    const callEtcTest = useCallback(() => {
        props.setEtc(true);
    }, [props]);

    const callRailplusTest = useCallback(() => {
        props.setRailplus(true);
    }, [props]);

    return (
        <div>
            <section className="contents myPageSetting">
                <div className="inner">
                    <div className="settingListWrap clfix">
                        <dl className="settingList2">
                            <dt><span className="tit">연동 테스트</span></dt>
                            <dd><button type="button" onClick={callCommonTest}><div className="icon"><img src="/assets/images/ico/icon_namecard.png" alt="주민등록증" /></div><span className="tit">공통</span></button></dd>
                            {/*<dd><button type="button" onClick={callPincodeTest}><div className="icon"><img src="/assets/images/ico/icon_namecard.png" alt="외국인등록증" /></div><span className="tit">거래비밀번호</span></button></dd>*/}
                            <dd><button type="button" onClick={callKeypadTest}><div className="icon"><img src="/assets/images/ico/icon_passport.png" alt="여권" /></div><span className="tit">보안키패드</span></button></dd>
                            <dd><button type="button" onClick={callPhotoUploadTest}><div className="icon"><img src="/assets/images/ico/icon_namecard.png" alt="운전면허증" /></div><span className="tit">사진업로드</span></button></dd>
                            <dd><button type="button" onClick={callAddressUploadTest}><div className="icon"><img src="/assets/images/ico/icon_namecard.png" alt="운전면허증" /></div><span className="tit">주소업로드</span></button></dd>
                            <dd><button type="button" onClick={callRailplusTest}><div className="icon"><img src="/assets/images/ico/icon_namecard.png" alt="운전면허증" /></div><span className="tit">교통카드</span></button></dd>
                            <dd><button type="button" onClick={callEtcTest}><div className="icon"><img src="/assets/images/ico/icon_namecard.png" alt="운전면허증" /></div><span className="tit">기타</span></button></dd>
                        </dl>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default TestMenu;